var resultBoxFrame = function(i,name) {
    var string = '<div class="col-lg-4 col-md-4">' +
            '<div class="chapter-box-'+ i +' result-box cf">' +
                    '<h3>'+name+'</h3>' +
                    '<canvas width="200" height="200"></canvas>' +
                    '<a class="detail" title="'+name+'">Detail</a>' +
            '</div>' +
        '</div>' ;
    var node = $.parseHTML(string);
    return node;
}

module.exports = resultBoxFrame;


//////////////////
// WEBPACK FOOTER
// ./src/result_box.js
// module id = 237
// module chunks = 0